import React from 'react';
import Classes from './BundleSellingPoint.scss';

const variants = {
  shop: 'shop',
  statistics: 'statistics',
  fastSales: 'fastSales',
} as const;

type BundleSellingPointProps = {
  variant: keyof typeof variants;
  title: string;
  description: string;
};
const BundleSellingPoint = ({ variant, title, description }: BundleSellingPointProps) => {
  const imageClassName = variants[variant] ? Classes[`image--${variants[variant]}`] : Classes['image--shop'];

  return (
    <div className={Classes.root}>
      <div className={Classes.circle}>
        <div className={`${Classes.image} ${imageClassName}`} />
      </div>
      <div className={Classes.title}>{title}</div>
      <p className={Classes.description}>{description}</p>
    </div>
  );
};

export { variants };

export default BundleSellingPoint;
